import type { BenefitPaymentType } from '@/features/shop-insurance/types';

export function getQuoteBenefitPaymentType(quote: { carrierName: string }): BenefitPaymentType {
  if (quote.carrierName === 'OneAmerica') return 'reimbursement';
  return 'indemnity';
}
